import { render, staticRenderFns } from "./shopping.vue?vue&type=template&id=087c4cd0&scoped=true&"
import script from "./shopping.vue?vue&type=script&lang=js&"
export * from "./shopping.vue?vue&type=script&lang=js&"
import style0 from "./shopping.vue?vue&type=style&index=0&id=087c4cd0&scoped=true&lang=scss&"
import style1 from "./shopping.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087c4cd0",
  null
  
)

export default component.exports